"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

require("./style.scss");
/**
* Book for a `LibraryShelf` Component.
*/


var LibraryBook = function LibraryBook(_a) {
  var accentColor = _a.accentColor,
      coverColor = _a.coverColor,
      detail = _a.detail,
      onClick = _a.onClick,
      style = _a.style,
      subtitle = _a.subtitle,
      textColor = _a.textColor,
      title = _a.title;
  return react_1.default.createElement("div", {
    className: "story-library-book",
    onClick: onClick,
    onKeyPress: onClick,
    role: "button",
    style: style,
    tabIndex: 0
  }, react_1.default.createElement("div", {
    className: "story-library-book__cover"
  }, react_1.default.createElement("div", {
    className: "story-library-book__cover__container",
    style: {
      background: accentColor
    }
  }, react_1.default.createElement("div", {
    className: "story-library-book__cover__content",
    style: {
      background: coverColor,
      color: textColor
    }
  }, react_1.default.createElement("div", {
    className: "story-library-book__cover__title"
  }, title), react_1.default.createElement("div", {
    className: "story-library-book__cover__subtitle"
  }, subtitle), react_1.default.createElement("div", {
    className: "story-library-book__cover__detail"
  }, detail)))));
};

LibraryBook.propTypes = {
  /** Color to style the cover's borders */
  accentColor: prop_types_1.default.string,

  /** Color to style the cover's background */
  coverColor: prop_types_1.default.string,

  /** Smallest text at the bottom of the `Book` */
  detail: prop_types_1.default.string,

  /** Click handler callback used by the `LibraryShelf` */
  onClick: prop_types_1.default.func,

  /** Styling object of the `Book` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object,

  /** Text underneath the title of the `Book` */
  subtitle: prop_types_1.default.string,

  /** Color to style the cover's text */
  textColor: prop_types_1.default.string,

  /** Largest text at the top of the `Book` */
  title: prop_types_1.default.string.isRequired
};
LibraryBook.defaultProps = {
  onClick: function onClick() {},
  accentColor: 'brown',
  coverColor: '#fefdf9',
  detail: '',
  style: {},
  subtitle: '',
  textColor: 'black'
};
exports.default = LibraryBook;